/**
 * @description all模式渲染后端返回路由
 * @param constantRoutes
 * @returns {*}
 */
export function convertRouter(asyncRoutes) {
    return asyncRoutes.map((route) => {
        if (route.component) {
            // Layout组件特殊处理
            if (route.component === 'Layout') {
                if (route.pid == 0) {

                    route.component = (resolve) => require(['@/layouts'], resolve)
                } else {
                    route.component = (resolve) =>
                        require(['@/layouts/EmptyLayout'], resolve)
                }
            } else {
                const index = route.component.indexOf('views')
                const path =
                    index > 0 ? route.component.slice(index) : `views/${route.component}`
                route.component = (resolve) => require([`@/${path}`], resolve)
            }
        }
        if (route.children && route.children.length)
            route.children = convertRouter(route.children)
        if (route.children && route.children.length === 0) delete route.children
        return route
    })
}

/**
 * @description 判断当前路由是否包含权限
 * @param permissions
 * @param route
 * @returns {boolean|*}
 */
function hasPermission(permissions, route) {
    if (route.meta && route.meta.permissions) {
        return permissions.some((role) => route.meta.permissions.includes(role))
    } else {
        return true
    }
}

/**
 * @description intelligence模式根据permissions数组拦截路由
 * @param routes
 * @param permissions
 * @returns {[]}
 */
export function filterAsyncRoutes(routes, permissions) {
    const finallyRoutes = []
    routes.forEach((route) => {
        const item = {
            ...route
        }
        if (hasPermission(permissions, item)) {
            if (item.children) {
                item.children = filterAsyncRoutes(item.children, permissions)
            }
            finallyRoutes.push(item)
        }
    })
    return finallyRoutes
}

/**

筛选出面包屑导航的路由
筛选出最后一个路由的整个树形结构
自定义查找字段, 根据最后一级某个字段查找完整树(整个父类)
@param {} val 要查找对比的值
@param {} data 要查找的数据
@param {*} fKey 要查找对比的字段
*/
export default function recursiveTreeByLastLevel(val, data, fKey = 'value') {
    let rData = [];
    for (let i = 0, len = data.length; i < len; i++) {
        rData.push(data[i]);
        if (data[i].children && data[i].children.length > 0) {
            rData = rData.concat(recursiveTreeByLastLevel(val, data[i].children, fKey));
            if (rData.some(item => item[fKey] === val)) return rData;
        }
        if (data[i][fKey] === val) return rData;
        rData = [];
    }
    return rData;
}